import React, { ReactNode } from 'react';

import { EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle, Empty as UIEmpty, cn } from '@column/ui';

export interface EmptyProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export const Empty: React.FC<EmptyProps> = ({ icon, title, description, action, className }) => (
  <UIEmpty className={cn('min-h-[300px]', className)}>
    <EmptyHeader>
      {icon && (
        <EmptyMedia variant="icon" className="[&_svg]:[--icon-color:currentColor]!">
          {icon}
        </EmptyMedia>
      )}
      <EmptyTitle>{title}</EmptyTitle>
      {description && <EmptyDescription>{description}</EmptyDescription>}
    </EmptyHeader>
    {action && <EmptyContent className="pointer-events-auto">{action}</EmptyContent>}
  </UIEmpty>
);
